'use strict';
(function () {
  if (customElements.get('fans-reviews')) return;

  class FansReviews extends HTMLElement {
    constructor() {
      super();
      this.swiper = null;
    }

    connectedCallback() {
      this.initSwiper();
      this.initImageModals();
    }

    initSwiper() {
      this.slider = this.querySelector('.fans-reviews__slider');
      if (!this.slider || typeof Swiper === 'undefined') return;

      this.nextBtn = this.querySelector('.swiper-button-next');
      this.prevBtn = this.querySelector('.swiper-button-prev');

      this.swiper = new Swiper(this.slider, {
        slidesPerView: 'auto',
        spaceBetween: 12,
        slidesOffsetAfter: 16,
        grabCursor: true,
        pagination: {
          el: this.querySelector('.swiper-pagination'),
          clickable: true,
        },
        breakpoints: {
          769: {
            slidesPerView: 4,
            slidesPerGroup: 2,
            spaceBetween: 16,
            slidesOffsetAfter: 0,
          },
        },
        on: {
          init: this.updateControls,
          slideChange: this.updateControls,
        },
      });

      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', () => this.swiper && this.swiper.slideNext());
      }
      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', () => this.swiper && this.swiper.slidePrev());
      }
      this.updateControls();
    }

    updateControls = () => {
      if (!this.swiper) return;

      // PC 箭头状态
      if (this.nextBtn && this.prevBtn) {
        if (this.swiper.isBeginning && this.swiper.isEnd) {
          this.prevBtn.classList.add('disabled');
          this.nextBtn.classList.add('disabled');
        } else if (this.swiper.isBeginning) {
          this.prevBtn.classList.add('disabled');
          this.nextBtn.classList.remove('disabled');
        } else if (this.swiper.isEnd) {
          this.prevBtn.classList.remove('disabled');
          this.nextBtn.classList.add('disabled');
        } else {
          this.prevBtn.classList.remove('disabled');
          this.nextBtn.classList.remove('disabled');
        }
      }
    };

    initImageModals() {
      // 点击评论缩略图时，先激活对应图片（modal-opener 负责打开弹层）
      this.querySelectorAll('.fans-reviews__image-btn').forEach((btn) => {
        btn.addEventListener('click', () => {
          const opener = btn.closest('modal-opener');
          const modal = opener && document.querySelector(opener.dataset.modal);
          if (modal) this.activateImage(modal, parseInt(btn.dataset.index, 10) || 0);
        });
      });

      // 弹层内左右切换
      document.querySelectorAll('.fans-reviews-modal').forEach((modal) => {
        const prev = modal.querySelector('.fans-reviews-modal__nav--prev');
        const next = modal.querySelector('.fans-reviews-modal__nav--next');
        if (prev) prev.addEventListener('click', () => this.stepImage(modal, -1));
        if (next) next.addEventListener('click', () => this.stepImage(modal, 1));
      });
    }

    stepImage(modal, step) {
      const images = modal.querySelectorAll('.fans-reviews-modal__image');
      if (images.length === 0) return;
      let current = Array.from(images).findIndex((img) => img.classList.contains('active'));
      if (current < 0) current = 0;
      this.activateImage(modal, (current + step + images.length) % images.length);
    }

    activateImage(modal, index) {
      const images = modal.querySelectorAll('.fans-reviews-modal__image');
      images.forEach((img, i) => img.classList.toggle('active', i === index));
    }
  }

  customElements.define('fans-reviews', FansReviews);
})();
